import styled from 'styled-components';

export const Container = styled.div``;

export const Title = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 1.5rem;
  color: #131e23;
  padding: 20px 20px;
  background: white;
  box-shadow: 0px 0px 6px 0px lightgrey;
  max-width: 800px;
  text-align: left;
  border-radius: 6px;
  margin-left: 0px;
  margin-top: 80px;

  @media (max-width: 560px) {
    text-align: center;
  }
`;

export const Answer = styled.div`
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 1.3rem;
  text-align: justify;
  color: white;
  margin-top: 20px;
  max-width: 800px;

  @media (max-width: 560px) {
    text-align: center;
  }
`;
